import { defineStore } from 'pinia';

interface UserState {
    id: number,
    name: string,
    role: string,
    avatar: string
}

export const useUserStore = defineStore('user', {
    state: (): UserState => ({
        id: 0,
        name: '',
        role: 'user',
        avatar: ''
    }),

    getters: {
        hasAvatar: (state) => !!state.avatar
    },

    actions: {
        update(id: number, name: string, role: string, avatar: string) {
            if (id) {
                this.id = id;
            }
            if (name) {
                this.name = name;
            }
            if (role) {
                this.role = role;
            }
            this.updateAvatar(avatar);
        },
        updateAvatar(avatar: string) {
            if (avatar) {
                if (!avatar.startsWith('http')) {
                    avatar = ''
                }
                this.avatar = avatar
            }
        },
        clear() {
            this.id = 0;
            this.name = '';
            this.role = 'user';
            this.avatar = '';
        }
    }
})